<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  width: 100%;
  height: 23.1vh;
  margin: 0 auto;
  color: #fff;
  text-align: center;

  // overflow: hidden;
  .area {
    width: 100%;
    height: 120%;
    margin-top: -1vh;

    .main {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<template>
  <boxWrap :name="name" :min="min">
    <div class="table">
      <div class="area">
        <div class="main"></div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from "../common/boxWrap";
import echarts from "echarts";
export default {
  data() {
    return {
      name: "近30天扫码趋势图",
      min: "box-wrap4",
      dataY: [],
      dataX: [],
      tableData: []
    };
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener(
        "resize",
        function () {
          this.myChart.resize();
        }.bind(this)
      );
    },
    getData() {
      this.myChart = echarts.init(document.querySelector(".area .main"));
      this.myChart.clear();
      this.chart();
    },
    fontSize(res) {
      let docEl = document.documentElement
      let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (!clientWidth) {
        return;
      }
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    chart() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.querySelector(".area .main"));
      this.myChart.setOption({
        grid: {
          top: "15%",
          left: "10%",
          right: "10%",
          bottom: "0%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#0177d4"
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              interval: 0,
              color: "#fff",
              fontSize: this.fontSize(0.16)
            },
            data: this.dataX
          }
        ],
        yAxis: [
          {
            type: "value",
            // splitLine: {
            //   show: false
            // },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#144088"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#144088"
              }
            },
            axisLabel: {
              interval: 0,
              color: "#30ABE7",
              fontSize: this.fontSize(0.14)
            }
          },
          {
            name: "数量：天/次",
            nameTextStyle: {
              color: "#fff",
              fontSize: this.fontSize(0.14),
              position: "right",
              padding: [10, 4, 0, -30]
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "注册总量",
            type: "line",
            smooth: false, // 是否平滑曲线显示
            showAllSymbol: true,
            symbol: "emptyCircle",
            symbolSize: this.fontSize(0.1),
            lineStyle: {
              normal: {
                color: "rgba(254, 54, 134, 1)" // 线条颜色
              }
            },
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#fff"
              }
            },
            itemStyle: {
              color: "#F33585",
              borderColor: "#F33585",
              borderWidth: this.fontSize(0.03)
            },
            tooltip: {
              show: false
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: "rgba(255, 96, 219, 0.3)"
                    },
                    {
                      offset: 0.8,
                      color: "rgba(255, 96, 219, 1)"
                    }
                  ],
                  false
                )
              }
            },
            data: [6212, 6582, 8135, 7810, 8000, 9000]
          }
        ]
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    var myDate = new Date();
    myDate.setDate(myDate.getDate() - 30);
    var dateArray = [];
    var dateTemp;
    var flag = 1;
    for (var i = 0; i < 6; i++) {
      myDate.setDate(myDate.getDate() + 5);
      let day = myDate.getDate();
      dateTemp = myDate.getMonth() + 1 + "-" + day;
      this.dataX.push(dateTemp);
    }

    var self = this;
    self.chart();
    self.init();
    this.timer = setInterval(() => {
      self.getData();
    }, 5000);
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?0d0462bc